import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e086fe96"),n=n(),_popScopeId(),n)
const _hoisted_1 = { style: {"display":"flex","align-items":"center"} }
const _hoisted_2 = { style: {"display":"flex","align-items":"center","padding":"10px 0"} }
const _hoisted_3 = { style: {"margin-left":"20px"} }
const _hoisted_4 = { style: {"display":"flex"} }
const _hoisted_5 = { style: {"display":"flex","align-items":"center"} }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "选择时间段", -1))
const _hoisted_7 = { style: {"margin-left":"14px"} }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"color":"#999"} }, "是否可用和其他优惠叠加使用", -1))
const _hoisted_9 = { style: {"display":"flex","align-items":"center"} }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "submit-fixed-wrap-placeholder" }, null, -1))
const _hoisted_11 = { class: "submit-fixed-wrap" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ui_title = _resolveComponent("ui-title")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_ui_form_item = _resolveComponent("ui-form-item")!
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_ui_choose_goods = _resolveComponent("ui-choose-goods")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_ui_card = _resolveComponent("ui-card")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_ui_form = _resolveComponent("ui-form")!
  const _component_ui_container = _resolveComponent("ui-container")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(_component_ui_container, { class: "com-wrap-box" }, {
    default: _withCtx(() => [
      _withDirectives((_openBlock(), _createBlock(_component_ui_form, {
        ref: "form",
        "label-position": "right",
        "label-width": "150px"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_ui_card, null, {
            title: _withCtx(() => [
              _createVNode(_component_ui_title, { title: "基本信息" })
            ]),
            default: _withCtx(() => [
              _createVNode(_component_ui_form_item, {
                required: true,
                error: "请输入优惠券名称",
                data: _ctx.formData.name,
                label: "名称"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.formData.name,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData.name) = $event)),
                    placeholder: "请输入优惠券名称"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }, 8, ["data"]),
              _createVNode(_component_ui_form_item, { label: "备注" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.formData.remake,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formData.remake) = $event)),
                    placeholder: "优惠券备注"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_ui_form_item, {
                required: true,
                label: "发放数量",
                error: "请输入优惠券发放数量",
                data: _ctx.formData.count
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    style: {"width":"160px"},
                    modelValue: _ctx.formData.count,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formData.count) = $event)),
                    modelModifiers: { number: true },
                    placeholder: "请输入发放数量"
                  }, {
                    append: _withCtx(() => [
                      _createTextVNode("张")
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              }, 8, ["data"]),
              _createVNode(_component_ui_form_item, {
                required: true,
                label: "可用商品范围"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_radio_group, {
                    modelValue: _ctx.formData.goodsType,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.formData.goodsType) = $event)),
                    class: "list-radio-group"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_radio, { label: 0 }, {
                        default: _withCtx(() => [
                          _createTextVNode("全部商品")
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_radio, { label: 1 }, {
                        default: _withCtx(() => [
                          _createTextVNode("指定商品")
                        ]),
                        _: 1
                      }),
                      (_ctx.formData.goodsType == 1)
                        ? (_openBlock(), _createBlock(_component_ui_choose_goods, {
                            key: 0,
                            modelValue: _ctx.formData.goodsList,
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formData.goodsList) = $event)),
                            style: {"margin-left":"24px"}
                          }, null, 8, ["modelValue"]))
                        : _createCommentVNode("", true),
                      _createVNode(_component_el_radio, { label: 2 }, {
                        default: _withCtx(() => [
                          _createTextVNode("指定商品不可用")
                        ]),
                        _: 1
                      }),
                      (_ctx.formData.goodsType == 2)
                        ? (_openBlock(), _createBlock(_component_ui_choose_goods, {
                            key: 1,
                            modelValue: _ctx.formData.goodsList,
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.formData.goodsList) = $event)),
                            style: {"margin-left":"24px"}
                          }, null, 8, ["modelValue"]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_ui_form_item, {
                label: "使用门槛",
                required: true
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_radio_group, {
                    modelValue: _ctx.formData.hasThreshold,
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.formData.hasThreshold) = $event)),
                    class: "list-radio-group"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_radio, { label: false }, {
                        default: _withCtx(() => [
                          _createTextVNode("无门槛")
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_radio, {
                        label: true,
                        style: {"display":"flex","align-items":"center"}
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_1, [
                            _createTextVNode(" 订单满 "),
                            _createVNode(_component_el_input, {
                              style: {"width":"100px","margin":"0 10px"},
                              modelValue: _ctx.formData.thresholdValue,
                              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.formData.thresholdValue) = $event)),
                              disabled: !_ctx.formData.hasThreshold
                            }, {
                              append: _withCtx(() => [
                                _createTextVNode("元")
                              ]),
                              _: 1
                            }, 8, ["modelValue", "disabled"]),
                            _createTextVNode(" 可用 ")
                          ])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              }),
              (_ctx.formData.type == 0)
                ? (_openBlock(), _createBlock(_component_ui_form_item, {
                    key: 0,
                    label: "优惠内容",
                    required: true,
                    data: _ctx.formData.price,
                    error: "请输入优惠金额"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" 减免 "),
                      _createVNode(_component_el_input, {
                        style: {"width":"140px","margin":"0 10px"},
                        modelValue: _ctx.formData.price,
                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.formData.price) = $event))
                      }, {
                        append: _withCtx(() => [
                          _createTextVNode("元")
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["data"]))
                : (_ctx.formData.type == 1)
                  ? (_openBlock(), _createBlock(_component_ui_form_item, {
                      key: 1,
                      label: "优惠内容",
                      required: true
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", null, [
                          _createTextVNode(" 打 "),
                          _createVNode(_component_el_input, { style: {"width":"140px","margin":"0 10px"} }, {
                            append: _withCtx(() => [
                              _createTextVNode("折")
                            ]),
                            _: 1
                          })
                        ]),
                        _createElementVNode("div", _hoisted_2, [
                          _createVNode(_component_el_checkbox),
                          _createElementVNode("div", _hoisted_3, [
                            _createTextVNode(" 最多优惠 "),
                            _createVNode(_component_el_input, { style: {"width":"100px","margin":"0 10px"} }, {
                              append: _withCtx(() => [
                                _createTextVNode("元")
                              ]),
                              _: 1
                            })
                          ])
                        ])
                      ]),
                      _: 1
                    }))
                  : (_ctx.formData.type == 2)
                    ? (_openBlock(), _createBlock(_component_ui_form_item, {
                        key: 2,
                        label: "优惠内容",
                        required: true
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("> 范围内随机 "),
                          _createVNode(_component_el_input, { style: {"width":"100px","margin":"0 10px"} }),
                          _createTextVNode(" 至 "),
                          _createVNode(_component_el_input, { style: {"width":"100px","margin":"0 10px"} }),
                          _createTextVNode("元 ")
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          _createVNode(_component_ui_card, null, {
            title: _withCtx(() => [
              _createVNode(_component_ui_title, { title: "限制规则" })
            ]),
            default: _withCtx(() => [
              _createVNode(_component_ui_form_item, {
                label: "用券时间",
                required: true
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_radio_group, {
                    modelValue: _ctx.formData.timeType,
                    "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.formData.timeType) = $event)),
                    class: "list-radio-group"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_4, [
                        _createVNode(_component_el_radio, {
                          label: 0,
                          disabled: !!_ctx.formData.id,
                          style: {"margin":"0  0 10px"}
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_5, [
                              _hoisted_6,
                              _createElementVNode("div", _hoisted_7, [
                                _createVNode(_component_el_date_picker, {
                                  "default-time": _ctx.defaultTime2,
                                  size: "default",
                                  onChange: _cache[9] || (_cache[9] = ($event: any) => (_ctx.formData.timeType = 0)),
                                  style: {"--el-input-height":"30px"},
                                  modelValue: _ctx.userTimeRange,
                                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.userTimeRange) = $event)),
                                  type: "datetimerange",
                                  "range-separator": "至",
                                  disabled: _ctx.formData.timeType != 0,
                                  "start-placeholder": "开始日期",
                                  "end-placeholder": "结束日期"
                                }, null, 8, ["default-time", "modelValue", "disabled"])
                              ])
                            ])
                          ]),
                          _: 1
                        }, 8, ["disabled"])
                      ]),
                      _createVNode(_component_el_radio, {
                        label: 1,
                        disabled: !!_ctx.formData.id,
                        style: {"display":"flex","align-items":"center"}
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(" 领券当日起 "),
                          _createVNode(_component_el_input, {
                            disabled: _ctx.formData.timeType != 1,
                            style: {"width":"80px","margin":"0 10px"},
                            modelValue: _ctx.formData.timeValue,
                            "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.formData.timeValue) = $event)),
                            modelModifiers: { number: true }
                          }, null, 8, ["disabled", "modelValue"]),
                          _createTextVNode("天内可用 ")
                        ]),
                        _: 1
                      }, 8, ["disabled"])
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_ui_form_item, { label: "能否叠加" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_checkbox, {
                    modelValue: _ctx.formData.overlap,
                    "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.formData.overlap) = $event)),
                    "true-label": true,
                    "false-label": false
                  }, {
                    default: _withCtx(() => [
                      _hoisted_8
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_ui_form_item, { label: "使用说明" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    type: "textarea",
                    style: {"width":"400px"},
                    modelValue: _ctx.formData.content,
                    "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.formData.content) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_ui_form_item, { label: "每人限领次数" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_radio_group, {
                    modelValue: _ctx.formData.hasGetCountLimit,
                    "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.formData.hasGetCountLimit) = $event)),
                    class: "list-radio-group"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_radio, { label: false }, {
                        default: _withCtx(() => [
                          _createTextVNode("不限次数")
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_radio, {
                        label: true,
                        style: {"display":"flex","align-items":"center"}
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_9, [
                            _createVNode(_component_el_input, {
                              modelValue: _ctx.formData.getCountValue,
                              "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.formData.getCountValue) = $event)),
                              style: {"width":"80px","margin":"0 10px"},
                              disabled: !_ctx.formData.hasGetCountLimit
                            }, null, 8, ["modelValue", "disabled"]),
                            _createTextVNode(" 次 ")
                          ])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _hoisted_10,
          _createElementVNode("div", _hoisted_11, [
            _withDirectives((_openBlock(), _createBlock(_component_el_button, {
              onClick: _ctx.submit,
              type: "primary"
            }, {
              default: _withCtx(() => [
                _createTextVNode("保存")
              ]),
              _: 1
            }, 8, ["onClick"])), [
              [_directive_loading, _ctx.submitLoading]
            ])
          ])
        ]),
        _: 1
      })), [
        [_directive_loading, _ctx.loading]
      ])
    ]),
    _: 1
  }))
}